import { EntityApi } from "../../services/ApiPlatform";
import { FinalResponse } from "../../services/ApiPlatform/models";

export abstract class CoordinatorRequestApi extends EntityApi {
    protected static GET_COLLECTION = "/api/coordinator-requests";

    protected static POST_COLLECTION = "/api/coordinator-requests";

    protected static GET_ITEM = "/api/coordinator-requests/{id}";

    protected static PUT_ITEM = "/api/coordinator-requests/{id}";

    protected static PATCH_ITEM = "/api/coordinator-requests/{id}";

    protected static DELETE_ITEM = "/api/coordinator-requests/{id}";

    protected static POST_COORDINATOR_CREATE =
        "/api/coordinator-requests/create-coordinator";

    public static async postCoordinatorCreate<R, P>(
        entity: P,
        extraParams = {}
    ): Promise<FinalResponse<R | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.POST_COORDINATOR_CREATE,
        };
        return this.postCollection(entity, extraParams);
    }
}
